/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import LandingPageLayout from '../components/layouts/LandingPageLayout';
import TeamPhoto from '../assets/images/LandingPage/teamphoto.png';
import AIAcceleratorBanner from '../components/_atoms/AIAcceleratorBanner';
import Image from 'next/image';
export const meta = {
  author: 'Jens Seip'
};
const MDXLayout = ({children}) => _jsx(LandingPageLayout, {
  mdx: true,
  meta: meta,
  title: "The Curipod Ambassador Program",
  subTitle: "Are you as passionate as us about sparking curiosity in classrooms?",
  image: TeamPhoto,
  children: children
});
function MDXContent(props = {}) {
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      h2: "h2",
      ul: "ul",
      li: "li",
      p: "p",
      a: "a"
    }, props.components);
    return _jsxs(_Fragment, {
      children: [_jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx(_components.h2, {
        children: "What do you get as a Curipod ambassador?"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "Have a major impact on the future of Curipod."
        }), "\n", _jsx(_components.li, {
          children: "Represent Curipod at events and conferences."
        }), "\n", _jsx(_components.li, {
          children: "The Curipod ambassador t-shirt."
        }), "\n", _jsx(_components.li, {
          children: "Exclusive access to the ambassador community."
        }), "\n", _jsx(_components.li, {
          children: "Curipod training with the founders of Curipod."
        }), "\n", _jsx(_components.li, {
          children: "And more!"
        }), "\n"]
      }), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx(_components.h2, {
        children: "Are you our next Curipod ambassador?"
      }), "\n", _jsx(_components.p, {
        children: "Take a peek at this checklist."
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "I am empathic and curious (Which are our core values in Curipod)."
        }), "\n", _jsx(_components.li, {
          children: "I love Curipod and the vision of sparking curiosity in the classroom - and would love to share the word in my local community."
        }), "\n", _jsx(_components.li, {
          children: "I actively participate in the Curipod community - either in our Facebook community or on Twitter, TikTok, Instagram)."
        }), "\n", _jsx(_components.li, {
          children: "I am based in the US (Don’t worry - we will soon be opening up for ambassadors in other regions)."
        }), "\n"]
      }), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx(_components.h2, {
        children: "The application process"
      }), "\n", _jsxs(_components.p, {
        children: ["Fill out ", _jsx(_components.a, {
          href: "https://share.hsforms.com/1zO8_TxagT7ODIvP_B3o3hg4evga",
          children: "this form"
        }), " to apply."]
      }), "\n", _jsx(_components.p, {
        children: "I am looking forward to hearing from you!"
      }), "\n", _jsx(_components.p, {
        children: "Jens Seip - co-founder & CEO"
      })]
    });
  }
}
export default MDXContent;
